module.exports = __webpack_public_path__ + "static/img/amazon.fdc4596a.png";